import { MonitorIcon, MoonIcon, SunIcon, type LucideIcon } from "lucide-react";

import type { ThemePreference } from "@/api/types";

/** A theme that is actually applied to the page ("system" resolved). */
export type ResolvedTheme = Exclude<ThemePreference, "system">;

export interface ThemeOption {
  value: ThemePreference;
  label: string;
  icon: LucideIcon;
}

/** Selectable theme preferences, in display order. */
export const THEME_OPTIONS: readonly ThemeOption[] = [
  { value: "system", label: "System", icon: MonitorIcon },
  { value: "light", label: "Light", icon: SunIcon },
  { value: "dark", label: "Dark", icon: MoonIcon },
];

export function isThemePreference(value: string): value is ThemePreference {
  return THEME_OPTIONS.some((option) => option.value === value);
}

export function oppositeTheme(theme: ResolvedTheme): ResolvedTheme {
  return theme === "dark" ? "light" : "dark";
}

export function themeOption(theme: ThemePreference): ThemeOption {
  return THEME_OPTIONS.find((option) => option.value === theme) ?? THEME_OPTIONS[0];
}
